export default {
    name: "events-list",
    data() {
        return {
            isLoading: true,
            search: '',
            isActiveEventsArchive: true,
            perPage: parseInt(this.postsPerPage),
            lastItem: parseInt(this.postsPerPage),
            posts: this.json,
            step: parseInt(this.loadStep),
            dateRange: {},
            today: new Date().getTime(),
        }
    },

    props: {
        json: [Object, Array],
        postsPerPage: [Number, String],
        loadStep: [Number, String],
        filterPlaceholder: String,
    },

    computed: {
        postsList() {
            let posts = this.posts;

            // Hide passed by events
            posts = posts.filter(post => {
                const hasEndDate = (post.end_date != '') ? true : false;

                const minEventDateArray = post.start_date.split('-'),
                    maxEventDateArray = post.end_date.split('-'),
                    eventStartDate = new Date(`${minEventDateArray[2]}-${minEventDateArray[1]}-${minEventDateArray[0]}`).getTime(),
                    eventEndDate = new Date(`${maxEventDateArray[2]}-${maxEventDateArray[1]}-${maxEventDateArray[0]}`).getTime();

                if (this.isActiveEventsArchive) {
                    return ((hasEndDate && eventEndDate > this.today) || (!hasEndDate && eventStartDate > this.today))
                } else {
                    return ((hasEndDate && eventEndDate < this.today) || (!hasEndDate && eventStartDate < this.today))
                }

            })

            // Sort Upcoming events by closest date
            posts = posts.sort((firstEvent, secondEvent) => {
                const firstEventMinDateArray = firstEvent.start_date.split('-'),
                    firstEventStartDate = new Date(firstEventMinDateArray[2], firstEventMinDateArray[1], firstEventMinDateArray[0]).getTime(),
                    secondEventMinDateArray = secondEvent.start_date.split('-'),
                    secondEventStartDate = new Date(secondEventMinDateArray[2], secondEventMinDateArray[1], secondEventMinDateArray[0]).getTime();

                var distancea = Math.abs(this.today - firstEventStartDate);
                var distanceb = Math.abs(this.today - secondEventStartDate);

                return distancea - distanceb;
            });

            // Filter by search keyword
            posts = posts.filter(post => {
                return post.title.toLowerCase().includes(this.search.toLowerCase())
            })

            // If date range is set - show events in this range
            if (this.dateRange.length > 0 && (this.dateRange[0] != null && this.dateRange[1] != null)) {
                posts = posts.filter(post => {
                    const hasEndDate = (post.end_date != '') ? true : false;

                    // Selected Date Range
                    const minDateArray = this.dateRange[0].split('-'),
                        maxDateArray = this.dateRange[1].split('-'),
                        minDate = new Date(minDateArray[2], minDateArray[1], minDateArray[0]).getTime(),
                        maxDate = new Date(maxDateArray[2], maxDateArray[1], maxDateArray[0]).getTime();

                    // Current Post Dates
                    const minEventDateArray = post.start_date.split('-'),
                        maxEventDateArray = post.end_date.split('-'),
                        eventStartDate = new Date(minEventDateArray[2], minEventDateArray[1], minEventDateArray[0]).getTime(),
                        eventEndDate = new Date(maxEventDateArray[2], maxEventDateArray[1], maxEventDateArray[0]).getTime();

                    // if event has end date comapre both dates, if not - compare only startdate
                    if (hasEndDate) {
                        return (eventStartDate >= minDate && eventStartDate <= maxDate) || (minDate >= eventStartDate && minDate <= eventEndDate);
                    } else {
                        return eventStartDate >= minDate && eventStartDate <= maxDate;
                    }
                })
            }
            // Return posts with all filters and sorted
            return posts;
        },

        displayedDate() {
            if (this.dateRange.length > 0 && (this.dateRange[0] != null && this.dateRange[1] != null)) {

                const start = this.dateRange[0].split('-'),
                    end = this.dateRange[1].split('-'),
                    startDate = new Date(start[2], start[1] - 1, start[0]),
                    endDate = new Date(end[2], end[1] - 1, end[0]);

                const Sday = new Intl.DateTimeFormat('en', {
                        day: 'numeric'
                    }).format(startDate),
                    Smonth = new Intl.DateTimeFormat('en', {
                        month: 'short'
                    }).format(startDate),
                    Eday = new Intl.DateTimeFormat('en', {
                        day: 'numeric'
                    }).format(endDate),
                    Emonth = new Intl.DateTimeFormat('en', {
                        month: 'short'
                    }).format(endDate);
                return `${Sday} ${Smonth} to ${Eday} ${Emonth}`;
            } else {
                return this.filterPlaceholder;
            }
        },

        printedPosts() {
            return this.postsList.slice(0, this.lastItem)
        },

        isButtonShowed() {
            return this.lastItem < this.postsList.length;
        },

        eventChangeText() {
            return (this.isActiveEventsArchive) ? 'See past events' : 'See future events';
        }
    },

    methods: {
        loadMore() {
            this.lastItem = this.lastItem + this.step;
        },
        updateValues(e) {
            console.log(e);
        },
        dateFormat(classes, date) {
            return date;
        },
        changeEvents() {
            this.isActiveEventsArchive = !this.isActiveEventsArchive;
            this.dateRange = {};
        }
    },
}